import { css, sva } from "@stubhub/broadway-foundation/css";

export const baseAccolade = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
  width: "full",
  paddingBlock: "primitives.50",
  paddingInline: "primitives.150",
  color: "text.onFill",
  textAlign: "center",
  desktop: {
    paddingBlock: "primitives.100",
    paddingInline: "primitives.200",
    color: "var(--component-accolade-color, {colors.text.onFill})",
    backgroundColor: "var(--component-accolade-background, initial)",
  },
});
export const baseAccoladeTextStart = css({
  textAlign: "start",
});
export const baseAccoladeTextEnd = css({
  textAlign: "end",
});

export const accoladeText = css({
  // eslint-disable-next-line panda/no-important -- TODO: remove `!important`
  color: "[inherit !important]",
});
export const accoladeTextGradient = css({
  // eslint-disable-next-line panda/no-important -- TODO: remove `!important`
  color: "[transparent !important]",
  backgroundGradient: "var(--component-accolade-gradient, initial)",
  backgroundClip: "[text]",
});

export const iconWrapper = css({
  display: "flex",
  flexShrink: 0,
});

export const performerLabelRecipe = sva({
  slots: ["root", "text", "icon"],
  className: "performerLabel",
  base: {
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      columnGap: "primitives.50",
      rowGap: "primitives.50",
      width: "full",
      minHeight: "[28px]",
      paddingInline: "primitives.200",
      textAlign: "center",
      backgroundColor: "var(--component-accolade-background, {colors.bg.surface.brand})",
    },
    text: {
      color: "var(--component-accolade-color, {colors.text})",
      fontSize: "var(--component-accolade-font-size, {fontSizes.primitives.350})",
      fontStyle: "var(--component-accolade-font-style, normal)",
      fontWeight: "var(--component-accolade-font-weight, {fontWeights.medium})",
      lineHeight: "var(--component-accolade-line-height, {lineHeights.primitives.500})",
      textAlign: "start",
    },
    icon: {
      display: "flex",
      flexShrink: 0,
      color: "var(--component-accolade-icon-color, {colors.text.brand})",
    },
  },
});
